var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3536 6.64645L7.17157 3.46447C6.97631 3.2692 6.65973 3.2692 6.46447 3.46447C6.2692 3.65973 6.2692 3.97631 6.46447 4.17157L8.79289 6.5H4C3.72386 6.5 3.5 6.72386 3.5 7C3.5 7.27614 3.72386 7.5 4 7.5H8.79289L6.46447 9.82843C6.2692 10.0237 6.2692 10.3403 6.46447 10.5355C6.65973 10.7308 6.97631 10.7308 7.17157 10.5355L10.3536 7.35355C10.5488 7.15829 10.5488 6.84171 10.3536 6.64645Z",
    fill: "#007CB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3C14.5 2.72386 14.7239 2.5 15 2.5H17C17.2761 2.5 17.5 2.72386 17.5 3C17.5 3.27614 17.2761 3.5 17 3.5H15C14.7239 3.5 14.5 3.27614 14.5 3Z",
    fill: "#007CB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5C14.7239 6.5 14.5 6.72386 14.5 7C14.5 7.27614 14.7239 7.5 15 7.5H17C17.2761 7.5 17.5 7.27614 17.5 7C17.5 6.72386 17.2761 6.5 17 6.5H15Z",
    fill: "#007CB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5C14.5 4.72386 14.7239 4.5 15 4.5H17C17.2761 4.5 17.5 4.72386 17.5 5C17.5 5.27614 17.2761 5.5 17 5.5H15C14.7239 5.5 14.5 5.27614 14.5 5Z",
    fill: "#007CB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H18C18.8284 0.5 19.5 1.17157 19.5 2V12C19.5 12.8284 18.8284 13.5 18 13.5H2C1.17157 13.5 0.5 12.8284 0.5 12V2ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V12C1.5 12.2761 1.72386 12.5 2 12.5H12.1V1.5H2ZM18 1.5H13.1V12.5H18C18.2761 12.5 18.5 12.2761 18.5 12V2C18.5 1.72386 18.2761 1.5 18 1.5Z",
    fill: "#007CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.e305ecd4df5f8dbd0cfb35d75a67915a.svg";
export { ForwardRef as ReactComponent };